import { Form, Input } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { MarkdownDescription } from 'app/components/commons/MarkdownDescription/MarkdownDescription';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

export const Menu = () => {
  const { isEditMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance();
  const menuValue = Form.useWatch('menu', form);

  return (
    <FormLineLayout
      label={<MarkdownDescription label="Menu" />}
      labelOnTop
      rightClassName="copywriting-form"
    >
      <Form.Item name="menu">
        {isEditMode ? (
          <Input.TextArea rows={2} />
        ) : (
          <span className="view-data">{menuValue ? menuValue : 'ø empty'}</span>
        )}
      </Form.Item>
    </FormLineLayout>
  );
};
